export class WrongFormatError extends Error {
  readonly name = "WrongFormatError";
}